module.exports = __webpack_public_path__ + "static/media/apetizer.9e774d09.jpg";